<template>
  <div>
    <!-- <v-overlay v-if="loading"> -->
    <div class="grid pa-12" v-if="this.loading == true">
      <Loader />
    </div>

    <div class="ma-12" v-if="this.loading == false">
      <v-row class="truncate">
        <v-avatar outline>
          <v-img v-if="this.avatar != ''" :src="this.avatar"></v-img>
          <svg
            v-else
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
            style="fill: currentcolor"
            aria-hidden="true"
            role="presentation"
            focusable="false"
          >
            <path
              d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
            ></path>
          </svg>
        </v-avatar>
        <div class="font-weight-bold">
          <v-row>
            <svg
              class="ma-4 svg-inline--fa fa-location-dot"
              height="20px"
              width="20px"
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="location-dot"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
            >
              <g class="fa-group">
                <path
                  class="fa-secondary"
                  fill="#F8955B"
                  d="M192 0C85.97 0 0 85.97 0 192c0 77.41 26.97 99.03 172.3 309.7c9.531 13.77 29.91 13.77 39.44 0C357 291 384 269.4 384 192C384 85.97 298 0 192 0zM192 271.1c-44.13 0-80-35.88-80-80S147.9 111.1 192 111.1s80 35.88 80 80S236.1 271.1 192 271.1z"
                ></path>
                <path
                  class="fa-primary"
                  fill="#b22af0"
                  d="M240 191.1c0 26.51-21.49 48-48 48S144 218.5 144 191.1S165.5 143.1 192 143.1S240 165.5 240 191.1z"
                ></path>
              </g>
            </svg>
            <p class="my-4" v-if="this.lenderView">
              {{ this.booking.borrowerName }} in {{ this.booking.suburb }}
            </p>
            <p class="my-4" v-if="this.borrowerView">
              {{ this.booking.lenderName }} in {{ this.suburb }}
            </p>
          </v-row>

          <p class="hidden-sm-and-down hidden-md-and-up">
            {{ this.startDate }}
          </p>
          <p class="hidden-sm-and-down hidden-md-and-up">
            {{ this.verified }}
          </p>
          <h5 class="font-weight-medium ml-5" v-if="startDate != null">
            Active since {{ this.startDate }}
          </h5>
          <v-row class="mt-6 mb-1">
            <svg
              :style="
                $vuetify.breakpoint.xsOnly
                  ? 'height: 10px; width: 10px; margin-right 5px !important;'
                  : '' && $vuetify.breakpoint.smAndDown
                  ? 'height: 30px; width: 30px; margin-right 5px !important;'
                  : 'height: 30px; width: 30px; margin-right 5px !important;' &&
                    $vuetify.breakpoint.mdAndUp
                  ? 'height: 18px; width: 18px; margin-right 5px !important;'
                  : 'height: 12px; width: 12px; margin-right 5px !important;'
              "
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="user-shield"
              class="svg-inline--fa fa-user-shield fa-w-20"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 512"
            >
              <g class="fa-group">
                <path
                  class="fa-secondary"
                  fill="#b22af0"
                  d="M224 256c70.7 0 128-57.31 128-128S294.7 0 224 0C153.3 0 96 57.31 96 128S153.3 256 224 256zM320.6 310.3C305.9 306.3 290.6 304 274.7 304H173.3C77.61 304 0 381.7 0 477.4C0 496.5 15.52 512 34.66 512H413.3c3.143 0 5.967-1.004 8.861-1.789C369.7 469.8 324.1 400.3 320.6 310.3z"
                ></path>
                <path
                  class="fa-primary"
                  fill="#F29E4D"
                  d="M622.3 271.1l-115.1-45.01c-4.125-1.629-12.62-3.754-22.25 0L369.8 271.1C359 275.2 352 285.1 352 295.1c0 111.6 68.75 188.8 132.9 213.9c9.625 3.75 18 1.625 22.25 0C558.4 489.9 640 420.5 640 295.1C640 285.1 633 275.2 622.3 271.1zM496 462.4V273.2l95.5 37.38C585.9 397.8 530.6 446 496 462.4z"
                ></path>
              </g>
            </svg>
            <p
              v-if="this.verified === true"
              class="mt-n1 mx-2 text-body-2 font-weight-bold"
            >
              Verified
            </p>
            <p
              v-if="this.verified === false"
              class="mt-n1 mx-2 text-body-2 font-weight-bold"
            >
              Not Verified
            </p>

            <svg
              :style="
                $vuetify.breakpoint.xsOnly
                  ? 'height: 10px; width: 10px; margin-right 5px !important;'
                  : '' && $vuetify.breakpoint.smAndDown
                  ? 'height: 30px; width: 30px; margin-right 5px !important;'
                  : 'height: 30px; width: 30px; margin-right 5px !important;' &&
                    $vuetify.breakpoint.mdAndUp
                  ? 'height: 18px; width: 18px; margin-right 5px !important;'
                  : 'height: 12px; width: 12px; margin-right 5px !important;'
              "
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="handshake"
              class="svg-inline--fa fa-handshake fa-w-20"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 512"
            >
              <g class="fa-group">
                <path
                  class="fa-secondary"
                  fill="#b22af0"
                  d="M480 128.2c-40.98-40.93-64.6-64.12-122.6-64.12c-10.49 0-19.93-.6141-30.2 8.566L217 163.6C196.8 180.7 194.2 210.1 211.4 231.2c9.5 11.21 23.03 16.99 36.67 16.99c10.94 0 21.95-3.716 30.97-11.33l39.57-33.46l165.3 135.3c4.361 3.536 7.123 8.173 9.078 13.04L544 351.1V128.4L480 128.2zM0 383.9l64 .0404c17.75 0 32-14.3 32-32.03V128.3L0 128.3V383.9zM48 320.1c8.75 0 16 7.124 16 15.99c0 8.735-7.25 15.99-16 15.99S32 344.8 32 336.1C32 327.2 39.25 320.1 48 320.1z"
                ></path>
                <path
                  class="fa-primary"
                  fill="#F09F54"
                  d="M318.6 203.4L279 236.8c-9.016 7.619-20.03 11.33-30.97 11.33c-13.64 0-27.17-5.777-36.67-16.99C194.2 210.1 196.8 180.7 217 163.6l110.3-90.9L280.9 64C223.6 64.37 168.8 87.48 128.2 127.9L96 128.3v223.6l50.25-.0904l90.5 81.82c27.5 22.35 67.75 18.1 90-9.246l18.12 15.24c15.88 12.98 39.38 10.48 52.38-5.371l31.38-38.6l5.374 4.498c13.75 10.99 33.88 8.991 45-4.748l9.538-11.78c11.08-13.69 8.985-33.83-4.694-44.93L318.6 203.4zM544 128.4v223.6c0 17.6 14.25 32.05 31.1 32.05L640 384V128.5L544 128.4zM592 352c-8.75 0-16-7.253-16-15.99c0-8.868 7.25-15.99 16-15.99s16 7.124 16 15.99C608 344.8 600.8 352 592 352z"
                ></path>
              </g>
            </svg>
            <p class="mt-n1 mx-2 text-body-2 font-weight-bold">
              Reviews: {{ reviewCount }}
            </p>
          </v-row>
        </div>
      </v-row>
      <v-row class="mt-n3">
        <v-btn
          v-if="borrowerView"
          class="appbutton mx-1 mt-4 white--text font-weight-medium"
          color="#b22af0"
          rounded
          style="margin-top: 30px !important"
          elevation="6"
          @click="$router.push('/profile/' + booking.lenderID)"
          z-index="12"
        >
          <v-icon x-small class="mr-1">fas fa-user</v-icon>View
          {{ booking.lenderName }}'s Profile
        </v-btn>

        <v-btn
          v-if="lenderView"
          class="appbutton mx-1 mt-4 white--text font-weight-medium"
          color="#b22af0"
          rounded
          style="margin-top: 30px !important"
          elevation="6"
          @click="$router.push('/profile/' + booking.borrowerID)"
          z-index="12"
        >
          <v-icon x-small class="mr-1">fas fa-user</v-icon>View
          {{ booking.borrowerName }}'s Profile
        </v-btn>

        <v-btn
          v-if="borrowerView"
          class="appbutton mx-1 mt-4 white--text font-weight-medium"
          color="#b22af0"
          rounded
          style="margin-top: 30px !important"
          elevation="6"
          @click="toInbox()"
          z-index="12"
        >
          Message {{ booking.lenderName
          }}<v-icon x-small class="ml-1">fas fa-chevron-right</v-icon>
        </v-btn>

        <v-btn
          v-if="lenderView"
          class="appbutton mx-1 mt-4 white--text font-weight-medium"
          color="#b22af0"
          rounded
          style="margin-top: 30px !important"
          elevation="6"
          @click="toInbox()"
          z-index="12"
        >
          Message {{ booking.borrowerName
          }}<v-icon x-small class="ml-1">fas fa-chevron-right</v-icon>
        </v-btn>
      </v-row>

      <!-- <v-text-field
        v-if="booking.comment"
        v-model="booking.comment"
        :label="borrowerView ? 'Your Comment' : 'Borrower Comment'"
        read-only=""
        class="mt-7 text--caption"
        color="white"
        outlined
        disabled
        autoGrow
        style="border-radius: 12px"
      /> -->

      <v-card
        v-if="borrowerView && booking.comment"
        outlined
        class="round pa-4 mt-7 text--caption"
      >
        <p><strong>Your comment:</strong> {{ booking.comment }}</p>
      </v-card>

      <v-card
        v-if="lenderView && booking.comment"
        outlined
        class="round pa-4 mt-7 text--caption"
      >
        <p>
          <strong> {{ booking.borrowerName }}'s' comment:</strong>
          {{ booking.comment }}
        </p>
      </v-card>

      <div class="mt-5 grid" v-if="borrowerView">
        <v-row class="d-flex justify-space-between">
          <v-row class="text-subtitle-2 mb-2 mt-6 mx-2">
            <span v-if="booking.delivery == true"
              >You have requested delivery to to</span
            >
            <span v-else-if="booking.delivery == false"
              >You have requested delivery to
              <svg
                height="15px"
                width="15px"
                aria-hidden="true"
                focusable="false"
                data-prefix="fad"
                data-icon="location-dot"
                class="svg-inline--fa fa-location-dot"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
              >
                <g class="fa-group">
                  <path
                    class="fa-secondary"
                    fill="#F8955B"
                    d="M192 0C85.97 0 0 85.97 0 192c0 77.41 26.97 99.03 172.3 309.7c9.531 13.77 29.91 13.77 39.44 0C357 291 384 269.4 384 192C384 85.97 298 0 192 0zM192 271.1c-44.13 0-80-35.88-80-80S147.9 111.1 192 111.1s80 35.88 80 80S236.1 271.1 192 271.1z"
                  ></path>
                  <path
                    fill="#B22AF0"
                    class="fa-primary secondary--text"
                    d="M240 191.1c0 26.51-21.49 48-48 48S144 218.5 144 191.1S165.5 143.1 192 143.1S240 165.5 240 191.1z"
                  ></path>
                </g>
              </svg>

              <span class="secondary--text ml-1 font-weight-bold truncate">{{
                booking.suburb
              }}</span>
              but will be collecting the item.</span
            >
            <span v-if="booking.delivery == true">
              <svg
                height="15px"
                width="15px"
                aria-hidden="true"
                focusable="false"
                data-prefix="fad"
                data-icon="location-dot"
                class="svg-inline--fa fa-location-dot"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
              >
                <g class="fa-group">
                  <path
                    class="fa-secondary"
                    fill="#F8955B"
                    d="M192 0C85.97 0 0 85.97 0 192c0 77.41 26.97 99.03 172.3 309.7c9.531 13.77 29.91 13.77 39.44 0C357 291 384 269.4 384 192C384 85.97 298 0 192 0zM192 271.1c-44.13 0-80-35.88-80-80S147.9 111.1 192 111.1s80 35.88 80 80S236.1 271.1 192 271.1z"
                  ></path>
                  <path
                    class="fa-primary secondary--text"
                    d="M240 191.1c0 26.51-21.49 48-48 48S144 218.5 144 191.1S165.5 143.1 192 143.1S240 165.5 240 191.1z"
                  ></path>
                </g>
              </svg>

              <span class="secondary--text ml-1 font-weight-bold">{{
                booking.suburb | truncate()
              }}</span>
            </span>
          </v-row>
        </v-row>
      </div>

      <div class="my-2 grid" v-if="lenderView">
        <v-row>
          <div class="text-subtitle-2 mb-2 mx-2 mt-8">
            <span v-if="booking.delivery == true"
              >{{ booking.borrowerName }} has requested delivery to</span
            >
            <span v-else-if="booking.delivery == false"
              >{{ booking.borrowerName }} will be using the item in
              <svg
                height="15px"
                width="15px"
                aria-hidden="true"
                focusable="false"
                data-prefix="fad"
                data-icon="location-dot"
                class="svg-inline--fa fa-location-dot"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
              >
                <g class="fa-group">
                  <path
                    class="fa-secondary"
                    fill="#F8955B"
                    d="M192 0C85.97 0 0 85.97 0 192c0 77.41 26.97 99.03 172.3 309.7c9.531 13.77 29.91 13.77 39.44 0C357 291 384 269.4 384 192C384 85.97 298 0 192 0zM192 271.1c-44.13 0-80-35.88-80-80S147.9 111.1 192 111.1s80 35.88 80 80S236.1 271.1 192 271.1z"
                  ></path>
                  <path
                    fill="#B22AF0"
                    class="fa-primary secondary--text"
                    d="M240 191.1c0 26.51-21.49 48-48 48S144 218.5 144 191.1S165.5 143.1 192 143.1S240 165.5 240 191.1z"
                  ></path>
                </g>
              </svg>

              <span class="secondary--text ml-1 font-weight-bold">{{
                booking.suburb
              }}</span>
              but will be collecting the item.</span
            >
            <span v-if="booking.delivery == true">
              <svg
                height="15px"
                width="15px"
                aria-hidden="true"
                focusable="false"
                data-prefix="fad"
                data-icon="location-dot"
                class="svg-inline--fa fa-location-dot"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
              >
                <g class="fa-group">
                  <path
                    class="fa-secondary"
                    fill="#F8955B"
                    d="M192 0C85.97 0 0 85.97 0 192c0 77.41 26.97 99.03 172.3 309.7c9.531 13.77 29.91 13.77 39.44 0C357 291 384 269.4 384 192C384 85.97 298 0 192 0zM192 271.1c-44.13 0-80-35.88-80-80S147.9 111.1 192 111.1s80 35.88 80 80S236.1 271.1 192 271.1z"
                  ></path>
                  <path
                    class="fa-primary secondary--text"
                    d="M240 191.1c0 26.51-21.49 48-48 48S144 218.5 144 191.1S165.5 143.1 192 143.1S240 165.5 240 191.1z"
                  ></path>
                </g>
              </svg>

              <span class="secondary--text ml-1 font-weight-bold">{{
                booking.suburb | truncate()
              }}</span>
            </span>
          </div>
        </v-row>
      </div>
      <!-- </v-card> -->
    </div>
  </div>
</template>

<script>
import { doc, getDoc, getFirestore } from "firebase/firestore";
import borrowerViewDTOVue from "./borrowerViewDTO.vue";

export default {
  name: "UserCard",
  props: {
    suburb: {
      type: String,
      required: true,
    },
    booking: {
      type: Object,
      required: true,
    },
    lenderView: {
      type: Boolean,
      required: true,
    },
    borrowerView: {
      type: Boolean,
      required: true,
    },
    cardUserId: {
      type: String,
      required: true,
    },
    startDate: {
      type: String,
      required: true,
    },
    cardUser: {
      type: Object,
      required: true,
    },
    avatar: {
      type: String,
      required: true,
    },
    verified: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      reqdString: "",
    };
  },

  components: {
    Loader: () => import("@/components/Loader.vue"),
  },

  filters: {
    truncate: function (value) {
      return value.substring(30, length) + "...";
    },
  },

  mounted() {
    console.log("@ user card: ");
    console.log("BoorwerView =", this.borrowerView);
    console.log("LenderView =", this.lenderView);
    console.log("booking at user card: ", this.booking);
    console.log("card user Id: ", this.cardUserId);
  },

  methods: {
    toInbox: function () {
      if (this.lenderView) {
        this.booking.created_by = this.booking.borrowerName;
        this.booking.userID = this.booking.borrowerID;
      } else {
        this.booking.created_by = this.booking.lenderName;
        this.booking.userID = this.booking.lenderID;
      }
      console.log("to inbox");
      localStorage.setItem("chatUser", JSON.stringify(this.booking));
      localStorage.setItem("chatUserAvatar", this.avatar);

      this.$router.push("/inbox");
    },
  },

  // async mounted() {
  //   try {
  //     this.loading = true;
  //     console.log('card user Id: ', this.cardUserId);
  //     this.id = this.cardUserId;
  //     console.log('id: ', this.id);

  //     const db = getFirestore();
  //     const docRef = doc(db, 'users', this.id);
  //     const docSnap = await getDoc(docRef);

  //     console.log('docSnap', docSnap);
  //     console.log('Document data:', docSnap.data());

  //     this.user = docSnap.data();
  //     let d = this.user.createdAt.seconds;
  //     var date = new Date(d * 1000).toString();
  //     date = date.substring(4, 15);
  //     this.startDate = date;
  //     console.log('date: ', this.startDate);
  //     this.loading = false;
  //   } catch (error) {
  //     console.log('Error getting user:', error);
  //     this.loading = false;
  //   }
  // },

  computed: {
    // userID() {
    //   console.log('computed prop:', this.cardUserId);
    // },

    reviewCount() {
      console.log("all reviews: ", this.$store.getters.loadedReviews);
      return this.$store.getters.loadedReviews.filter(
        (review) =>
          review.itemId === this.booking.itemID && review.reviewType === "item"
      ).length;
    },

    rateItems() {
      // get a count of the loadedItems that have a userID that matches the cardUserId
      //get average rating count from reviews
      let count = 0;
      let total = 0;
      let average = 0;
      let reviews = this.$store.getters.loadedReviews.filter(
        (review) =>
          review.userId === this.cardUserId && review.reviewType === "item"
      );
      console.log("reviews: ", reviews);
      reviews.forEach((review) => {
        total += review.rating;
        count++;
      });
      average = total / count;
      console.log("average: ", average);
      return average;
    },
  },
};
</script>

<style lang="scss" scoped>
.truncate {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
